import React, { useEffect } from "react";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Chip,
  Tooltip,
  Avatar,
  Zoom,
  IconButton,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import moment from 'moment';
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import UpgradeIcon from '@mui/icons-material/UpgradeOutlined';



export default function ActiveSubscription({plan, onUpgrade}){
    return (
      <Box>
        {/* Active Plans */}
        <Card
          sx={{
            maxWidth: 650,
            margin: "auto",
            mt: 6,
            borderRadius: 5,
            boxShadow: "0px 12px 40px rgba(0,0,0,0.2)",
            overflow: "hidden",
            background: "linear-gradient(145deg, #0f2027, #203a43, #2c5364)",
            color: "white",
          }}
        >
          {/* Premium Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
              p: 3,
              display: "flex",
              justifyContent : "space-between",
              gap: 1.5,
            }}
          >
            <Box display={'flex'} gap={"4px"}>

            <WorkspacePremiumIcon fontSize="large" sx={{ color: "#fff" }} />
            <Typography variant="h4" fontWeight="bold">
              {plan.status} Subscription
            </Typography>
            </Box>

              <Button
                variant="contained"
                color="success"
                startIcon={<UpgradeIcon />}
                onClick={()=>onUpgrade(plan)}
              >
                Upgrade Plan
              </Button>
          </Box>

          <CardContent sx={{ p: 4 }}>
            {/* Dates */}
            <Grid container spacing={3} sx={{ mb: 2 }}>
              <Grid item xs={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <EventIcon sx={{ color: "#00e676" }} />
                  Start Date:
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  {/* Format date here */}
                  {moment(plan?.startDate).format("DD-MMM-YYYY") || "—"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <EventIcon sx={{ color: "#ff1744" }} />
                  End Date:
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  {/* Format date here */}
                  {moment(plan?.endDate).format("DD-MMM-YYYY") || "—"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <MonetizationOnIcon sx={{ color: "#4caf50" }} />
                  Amount Paid:
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  ₹ {plan.amount}
                </Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3, borderColor: "rgba(255,255,255,0.2)" }} />

            {/* Benefits */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              🌟 Benefits
            </Typography>
            <Grid container spacing={1} sx={{ mb: 3 }}>
              {plan?.benefits?.length > 0 ? (
                plan.benefits?.map((benefit, index) => (
                  <Zoom
                    in
                    key={index}
                    style={{ transitionDelay: `${index * 100}ms` }}
                  >
                    <Grid item>
                      <Chip
                        label={`${
                          !benefit.restricted ? "Unlimited" : benefit.value
                        } ${benefit.label}`}
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(45deg, #43cea2, #185a9d)",
                          color: "white",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        }}
                      />
                    </Grid>
                  </Zoom>
                ))
              ) : (
                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                  No benefits listed
                </Typography>
              )}
            </Grid>

            {/* Features */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              💎 Features
            </Typography>
            <Grid container spacing={1}>
              {plan?.features?.length > 0 ? (
                plan.features.map((feature, index) => (
                  <Zoom
                    in
                    key={index}
                    style={{ transitionDelay: `${index * 100}ms` }}
                  >
                    <Grid item>
                      <Tooltip title={feature}>
                        <Chip
                          avatar={
                            <Avatar
                              sx={{
                                background:
                                  "linear-gradient(45deg, #ff6a00, #ee0979)",
                                fontWeight: "bold",
                              }}
                            >
                              {feature.charAt(0)}
                            </Avatar>
                          }
                          label={feature}
                          sx={{
                            fontWeight: "bold",
                            background:
                              "linear-gradient(45deg, #ff6a00, #ee0979)",
                            color: "white",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                          }}
                        />
                      </Tooltip>
                    </Grid>
                  </Zoom>
                ))
              ) : (
                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                  No features listed
                </Typography>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    );
}
